import axios from "axios";
import { getCookie } from "./cookies";
import { env } from "./function";

axios.defaults.baseURL = env("SERVER");
// axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
  const accessToken = getCookie("accessToken");
  if (accessToken && accessToken !== "undefined") {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});
